import React from 'react';
import styles from '../../asset/styles/packages/packages.module.scss';

const Packages: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageHeader}>
        <h1>Packages</h1>
        <button className={styles.btnPrimary}>Add New Package</button>
      </div>
      
      <div className={styles.packagesContent}>
        <div className={styles.emptyState}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#E0E0E0" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2v20M2 12h20" />
          </svg>
          <h3>No Packages Yet</h3>
          <p>Start creating travel packages for your customers</p>
          <button className={styles.btnPrimary}>Create Package</button>
        </div>
      </div>
    </div>
  );
};

export default Packages;

